// despite importing 'babel-polyfill' this is required for polyfilling `forEach`
// thx to: https://developer.mozilla.org/de/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}



// WEBPACK FOOTER //
// ./polyfills.js